import { isPlaygroundUid } from "./uid";

/** 挂件上报的行为事件，字段见 `contract/schemas/widget-event-request.schema.json`。 */
export type WidgetEventName = "message_sent";

export interface ReportWidgetEventInput {
  handshakeUrl: string;
  event: WidgetEventName;
  uid: string;
  conversationId: string;
  customerName?: string;
}

/**
 * 走 App Proxy 把行为事件交给 BFF 转发（GON-20、GON-10）。
 * `message_sent` 每条被后端收下的买家消息一次；
 * 打开挂件、浏览页面都不上报。Playground 的 `test:` 身份不上报。
 * 上报失败静默丢弃：指标少一条也不能打断买家聊天。
 */
export async function reportWidgetEvent(
  {
    handshakeUrl,
    event,
    uid,
    conversationId,
    customerName,
  }: ReportWidgetEventInput,
  fetchImpl: typeof fetch = fetch,
): Promise<void> {
  if (isPlaygroundUid(uid)) return;
  try {
    const url = new URL(handshakeUrl, location.href);
    url.pathname = url.pathname.replace(/\/handshake$/, "/events");
    await fetchImpl(url.href, {
      body: JSON.stringify({
        event,
        uid,
        conversation_id: conversationId,
        ...(customerName ? { customer_name: customerName } : {}),
      }),
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      // 买家发完就点商品卡走人是常态，不带 keepalive 这条上报会被浏览器掐断。
      keepalive: true,
      method: "POST",
      signal: AbortSignal.timeout(8_000),
    });
  } catch {
    /* 上报失败不影响买家聊天。 */
  }
}
